import { HIDE } from '../../utils/constants';

export function toggleLoading(state) {
    const el = document.querySelector('.loading__wrapper.loading__overlay, .assistant__iframe .loading__wrapper');
    if (!el) return;
    if (state) {
        el.classList.remove('hidden');
    } else {
        el.classList.add('hidden');
    }
}

export function toggleLoadingIframe(state) {
    const loadingClass = document.querySelector('.loading__widget').classList;
    if (state === HIDE) {
        loadingClass.add('hidden');
    } else if (state) {
        loadingClass.add('show-screen');
        loadingClass.remove('hidden');
    } else {
        loadingClass.remove('show-screen');
        loadingClass.remove('hidden');
    }
}

export function setLoadingColor(color) {
    document.querySelectorAll('.loading__wrapper svg rect').forEach((i) => {
        i.setAttribute('fill', color);
    });
}
